var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoupons(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11697_73494)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.25 11.0106V5.01062C14.25 4.18562 13.575 3.51062 12.75 3.51062H2.25C1.425 3.51062 0.75 4.18562 0.75 5.01062V11.0106C0.75 11.8356 1.425 12.5106 2.25 12.5106H12.75C13.575 12.5106 14.25 11.8356 14.25 11.0106ZM12.75 11.0106H2.25V5.01062H12.75V11.0106ZM7.5 5.76062C6.255 5.76062 5.25 6.76562 5.25 8.01062C5.25 9.25562 6.255 10.2606 7.5 10.2606C8.745 10.2606 9.75 9.25562 9.75 8.01062C9.75 6.76562 8.745 5.76062 7.5 5.76062ZM17.25 5.76062V14.0106C17.25 14.8356 16.575 15.5106 15.75 15.5106H3C3 14.7606 3 14.8356 3 14.0106H15.75V5.76062C16.575 5.76062 16.5 5.76062 17.25 5.76062Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11697_73494"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0 0.51001)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoupons);
export default __webpack_public_path__ + "static/media/Coupons.968558083ee76db4dd8106b73cbba0cf.svg";
export { ForwardRef as ReactComponent };